import React from 'react';
import { Form } from 'react-bootstrap';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const styles = {
    root: {
        color: '#bbbbbb',
        '&$checked': {
            color: '#ff6e40',
        }
    },
    checked: {}
}


type Props = {
    handleChange?: () => void,
    timeFilterChanged: (e: any, type: string) => void,
    violationsCountChanged: (e: any) => void,
    ViolationTypeCheckingAll?: () => void,
    ViolationTypeCheckingSeatBelt?: () => void,
    ViolationTypeCheckingCellphone?: () => void,
    ViolationTypeCheckingQueneJumping?: () => void,
    ViolationTypeCheckingRedLight?: () => void,
    ViolationTypeCheckingTrespassZebra?: () => void,
    ViolationTypeCheckingWrongTurn?: () => void,
    ViolationTypeCheckingWrongWay?: () => void,
    ViolationTypeCheckingSpeed?: () => void,
    ViolationTypeCheckingSpotSpeed?: () => void,
    ViolationTypeStatusAll?: boolean,
    ViolationTypeStatusSeatBelt?: boolean,
    ViolationTypeStatusCellphone?: boolean,
    ViolationTypeStatusQueneJumping?: boolean,
    ViolationTypeStatusRedLight?: boolean,
    ViolationTypeStatusTrespassZebra?: boolean,
    ViolationTypeStatusWrongTurn?: boolean,
    ViolationTypeStatusWrongWay?: boolean,
    ViolationTypeStatusSpeed?: boolean
    ViolationTypeStatusSpotSpeed?: boolean
    classes?: object
};

export const Filter = (props: Props) => (
    <div>
        <form noValidate>
            <div className="timeDatePicker">
                <span id="datepickerEnd">From</span>
                <TextField
                    id="dateFrom"
                    type="date"
                    defaultValue=""
                    onChange={(e) => props.timeFilterChanged && props.timeFilterChanged(e, 'dateFrom')}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </div>
            <div className="timeDatePicker">
                <TextField
                    id="timeFrom"
                    type="time"
                    defaultValue=""
                    onChange={(e) => props.timeFilterChanged && props.timeFilterChanged(e, 'timeFrom')}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    inputProps={{
                        step: 300, // 5 min
                    }}
                />
            </div>
            <div id="forInterspace"></div>
            <div className="timeDatePicker">
                <span id="datepickerStart">To</span>
                <TextField
                    id="dateTo"
                    type="date"
                    onChange={(e) => props.timeFilterChanged && props.timeFilterChanged(e, 'dateTo')}
                    defaultValue=""
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </div>
            <div className="timeDatePicker">
                <TextField
                    id="timeTo"
                    type="time"
                    defaultValue=""
                    onChange={(e) => props.timeFilterChanged && props.timeFilterChanged(e, 'timeTo')}
                    //className={classes.textField}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    inputProps={{
                        step: 300, // 5 min
                    }}
                />
            </div>
            <div className="timeDatePicker">
                <span id="violations-per-page">Events Per Page</span>

                <TextField
                    id="violations_count"
                    defaultValue="100"
                    type="number"
                    onChange={(e) => props.violationsCountChanged && props.violationsCountChanged(e)}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    inputProps={{
                        step: 10,
                    }}
                />
            </div>


        </form>
        <Form inline id="TypeSecaltion">
            Event Type
            <Checkbox
                checked={props.ViolationTypeStatusAll}
                onChange={props.ViolationTypeCheckingAll}
                value="checkedB"
                classes={{
                    ...props.classes
                }}
            />
            All
            <Checkbox
                checked={props.ViolationTypeStatusSeatBelt}
                onChange={props.ViolationTypeCheckingSeatBelt}
                classes={{
                    ...props.classes
                }}
            />
            SeatBelt
            <Checkbox
                checked={props.ViolationTypeStatusCellphone}
                onChange={props.ViolationTypeCheckingCellphone}
                classes={{
                    ...props.classes
                }}
            />
            Cellphone
            <Checkbox
                checked={props.ViolationTypeStatusQueneJumping}
                onChange={props.ViolationTypeCheckingQueneJumping}
                classes={{
                    ...props.classes
                }}
            />
            Queue Jumping
            <Checkbox
                checked={props.ViolationTypeStatusRedLight}
                onChange={props.ViolationTypeCheckingRedLight}
                classes={{
                    ...props.classes
                }}
            />
            Red Light

            <Checkbox
                checked={props.ViolationTypeStatusTrespassZebra}
                onChange={props.ViolationTypeCheckingTrespassZebra}
                classes={{
                    ...props.classes
                }}
            />

            Trespass Zebra

            <Checkbox
                checked={props.ViolationTypeStatusWrongTurn}
                onChange={props.ViolationTypeCheckingWrongTurn}
                classes={{
                    ...props.classes
                }}
            />
            Wrong Turn
            <Checkbox
                checked={props.ViolationTypeStatusWrongWay}
                onChange={props.ViolationTypeCheckingWrongWay}
                classes={{
                    ...props.classes
                }}
            />
            Wrong Way
            <Checkbox
                checked={props.ViolationTypeStatusSpeed}
                onChange={props.ViolationTypeCheckingSpeed}
                classes={{
                    ...props.classes
                }}
            />
            Avg. Speed
            <Checkbox
                checked={props.ViolationTypeStatusSpotSpeed}
                onChange={props.ViolationTypeCheckingSpotSpeed}
                classes={{
                    ...props.classes
                }}
            />
            Spot Speed
        </Form>
    </div>
)

export default withStyles(styles);


// WEBPACK FOOTER //
// ./src/components/Common/Filter.tsx